import { withStyles } from '@material-ui/styles';
import { Box } from '@material-ui/core';
import { centerBoxProps } from 'globals/utils';

export default withStyles(() => ({
  root: {
    ...centerBoxProps,
  },
}))(Box);
